import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

globalThis.Pusher = Pusher;

const echo = new Echo({
    broadcaster: 'reverb',
    key: process.env.VUE_APP_REVERB_APP_KEY,
    wsHost: process.env.VUE_APP_REVERB_HOST,
    wsPort: Number(process.env.VUE_APP_REVERB_PORT),
    wssPort: Number(process.env.VUE_APP_REVERB_PORT),
    forceTLS: process.env.VUE_APP_REVERB_SCHEME === 'https',
    enabledTransports: ['ws', 'wss'],
    channelAuthorization: {
        endpoint: `${process.env.VUE_APP_API_URL}/broadcasting/auth`,
        transport: 'ajax',
        headersProvider: () => {
            const token = localStorage.getItem('token');
            return {
                Accept: 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            };
        },
    },
});

echo.connector.pusher.connection.bind('state_change', () => {});

echo.connector.pusher.connection.bind('error', error => {
    console.error('Reverb error:', error);
});

window.Echo = echo;

export default echo;